export const    SHOW_NOTIFICATIONS  = "SHOW_NOTIFICATIONS"
,               SHOW_MEMBERS        = "SHOW_MEMBERS"
,               SHOW_PROFILE        = "SHOW_PROFILE"
,               SHOW_FORUM          = "SHOW_FORUM"
,               SHOW_RESOURCES      = "SHOW_RESOURCES"
,               SHOW_BOARDS         = "SHOW_BOARDS"

,               ROLE_ADMIN          = "ADMIN"
,               ROLE_GLOBAL_ADMIN   = "GLOBAL_ADMIN"
,               ROLE_MEMBER         = "MEMBER"

,               POST                = "POST"
,               RESOURCE            = "RESOURCE"

,               VIEW_ALL            = "ALL"

,               ATTACH_LINK         = "LINK"
,               ATTACH_FILE         = "FILE"
,               ATTACH_UNKNOWN      = "UNKNOWN"
,               ATTACH_IMAGE        = "IMAGE"

,               FILTER_DEFAULT      = "general";



// WEBPACK FOOTER //
// ./src/configuration/consts.ts